import React, { FC } from 'react'
import Accordion from '../../../../../components/Organisms/Accordion/Accordion'
import Button from '../../../../../components/Atoms/Button/Button'
import Font from '../../../../../components/Core/Typography/Font/Font'
import useForm, { OnSubmitParams } from '../../../../../components/Core/Hooks/useForm/useForm'
import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'
import utils from '../../../../../components/Organisms/Form/utils'
import config from './config'
import t from '../../../../../translations/main'
import { FormProps } from '../../../../Pages/Onboarding/types'
import { ExternalLink } from '../../../../../components/Core//Styles/Link'
import { Trans } from 'react-i18next'

const fcaHandbookLink = (
  <ExternalLink href='https://www.handbook.fca.org.uk/handbook' />
)

const ConsentsForm: FC<FormProps> = props => {
  const submitForm = (data: OnSubmitParams) => {
    const { submit } = props
    if (submit) submit(data)
  }

  const {
    formData,
    emptyValidation,
    handleInputChange,
    handleSubmit,
    configData,
  } = useForm(props.fetchedData, config, submitForm)

  return (
    <FormStyle onSubmit={handleSubmit}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.ConsentsForm.title')}
        </FormTitle>
      </FormHeader>
      <Accordion
        title={t(
          'onboarding.forms.CorporateAccount.ConsentsForm.accordion.title'
        )}
        isOpen
      >
        <Font>
          {/* @ts-ignore */}
          <Trans
            i18nKey={
              'onboarding.forms.CorporateAccount.ConsentsForm.accordion.content'
            }
          />
        </Font>
      </Accordion>
      {utils.sectionBuilder(configData, formData, handleInputChange)}
      <Font>
        {/* @ts-ignore */}
        <Trans
          i18nKey={
            'onboarding.forms.CorporateAccount.ConsentsForm.moreInfoText'
          }
          components={{ fcaHandbookLink }}
        />
      </Font>
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
            disabled={emptyValidation}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default ConsentsForm
